import { defineRecipe } from '@chakra-ui/react/styled-system';

const controlButtonRecipe = defineRecipe({
  className: 'control-button',
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '4',
    cursor: 'pointer',
    background: 'transparent',
    _disabled: {
      cursor: 'not-allowed',
      _hover: {
        background: 'transparent',
      },
      _active: {
        background: 'transparent',
      },
    },
  },
  variants: {
    isDanger: {
      false: {
        color: 'button/control/fg',
        _hover: {
          background: 'button/control/bg-hover',
          color: 'button/control/fg-hover',
          _active: {
            background: 'button/control/bg-active',
            color: 'button/control/fg-active',
          },
        },
        _active: {
          background: 'button/control/bg-active',
          color: 'button/control/fg-active',
        },
        _disabled: {
          color: 'button/control/fg-disabled!',
        },
      },
      true: {
        color: 'button/control-danger/fg',
        _hover: {
          background: 'button/control-danger/bg-hover',
          color: 'button/control-danger/fg-hover',
          _active: {
            background: 'button/control-danger/bg-active',
            color: 'button/control-danger/fg-active',
          },
        },
        _active: {
          background: 'button/control-danger/bg-active',
          color: 'button/control-danger/fg-active',
        },
        _disabled: {
          color: 'button/control-danger/fg-disabled!',
        },
      },
    },
    size: {
      xxs: { padding: '4' },
      xs: { padding: '8' },
      sm: { padding: '4' },
      md: { padding: '8' },
      lg: { padding: '12' },
    },
  },
  defaultVariants: {
    isDanger: false,
    size: 'sm',
  },
});

export default controlButtonRecipe;
